import EditorDial from '@/components/Dial/EditorDial';
import { useSessionStore } from '@/hooks/useSessionStore';
import useEditorStore, { EditorOperatorEnum } from '@/state/editor-store';
import React from 'react';
import { EditorOperatorConfigMap } from '../../../module/util';
import { CreditDisplay } from './CreditDisplay';
import { DurationInput } from './DurationInput';
import { useDurationControl } from './useDurationControl';

const EMPTY_PANEL_STYLES = 'flex-1 aspect-square bg-gradient-to-br from-[#383a3c] to-[#2b2e2f] rounded border border-[#46494c]';

const ControlPanel: React.FC = () => {
  const { operator, editor } = useEditorStore((state) => ({
    operator: state.operator,
    editor: state.editor,
  }));

  const { session } = useSessionStore();

  const { duration, disabled, handleChange, handleBlur, handleDialChange } = useDurationControl(operator as EditorOperatorEnum, editor);

  const config = EditorOperatorConfigMap?.[operator as EditorOperatorEnum];

  return (
    <div className="flex flex-col bg-zinc-900 w-[90px] rounded-xl gap-1">
      <CreditDisplay
        creditValue={session?.user?.credit?.value ?? 0}
        onUpgradeClick={() => window.open('/recharge?tab=business', '_blank')}
      />

      <div className={EMPTY_PANEL_STYLES} />

      <DurationInput duration={duration} disabled={disabled} onChange={handleChange} onBlur={handleBlur} />

      <div className={`${EMPTY_PANEL_STYLES} p-2 relative flex items-center justify-center ${disabled ? 'opacity-50' : ''}`}>
        <EditorDial initValue={config?.default} onChange={handleDialChange} disabled={disabled} />
      </div>
    </div>
  );
};

export default ControlPanel;
